/* eslint-disable default-case */
import fire from '../utils/firebase/firebase';
import {
  SET_PROGRAMAS,
  LOADING,
  SET_PROGRAMA_UPDATED,
  ERROR,
  IMAGE_UPLOADED,
  LOADING_IMAGE,
  SET_PROGRAMA_CREATED,
} from './ActionTypes';
import * as firebase from 'firebase';

export const fetchDataRD = async (dispatch) => {
  dispatch({
    type: LOADING,
  });
  await fire
    .database()
    .ref('/programas')
    .once('value', function (snapshot) {
      const list = snapshot.val().sort((a, b) => a.pregrado > b.pregrado);
      dispatch({
        type: SET_PROGRAMAS,
        payload: list,
      });
    });
};

export const fetchData = async (dispatch) => {
  dispatch({
    type: LOADING,
  });
  fire
    .firestore()
    .collection('programas')
    .orderBy('pregrado')
    .get()
    .then((querySnapshot) => {
      const list = [];
      querySnapshot.forEach((doc) => list.push({ ...doc.data(), id: doc.id }));
      dispatch({
        type: SET_PROGRAMAS,
        payload: list,
      });
    });
};

export const createPrograma = async (dispatch, programa) => {
  dispatch({
    type: LOADING,
  });

  fire
    .firestore()
    .collection('programas')
    .add(programa)
    .then((res) => {
      dispatch({
        type: SET_PROGRAMA_CREATED,
        payload: { ...programa, id: res.id },
      });
    })
    .catch((error) => {
      dispatch({
        type: ERROR,
        payload: error.message,
      });
    });
};

export const updatePrograma = async (dispatch, programas, programa) => {
  dispatch({
    type: LOADING,
  });
  try {
    await fire
      .firestore()
      .collection('programas')
      .doc(programa.id)
      .update(programa);

    const index = programas.findIndex((p) => p.id == programa.id);
    /** 
    const listUpdated = programas.map(prog => {
      if (prog.id == programa.id)
        return Object.assign({}, prog, { ...programa });
      return prog;
    });
*/
    dispatch({
      type: SET_PROGRAMA_UPDATED,
      payload: programa,
      indexToUpdate: index,
      listToUpdate: programas,
    });
  } catch (error) {
    dispatch({
      type: ERROR,
      payload: error.message,
    });
  }
};

export const addArea = async (dispatch, area) => {
  dispatch({
    type: LOADING,
  });
  try {
    const result = await fire
      .firestore()
      .collection('areas')
      .doc(area.id.toString())
      .set(area);

    dispatch({
      type: SET_PROGRAMA_UPDATED,
    });
  } catch (error) {
    dispatch({
      type: ERROR,
      payload: error.message,
    });
  }
};

export const uploadFile = async (dispatch, file, area) => {
  dispatch({
    type: LOADING_IMAGE,
  });
  let urlRef = '';
  switch (area) {
    case '1':
      urlRef = 'programas/ciencias naturales/';
      break;
    case '2':
      urlRef = 'programas/ingenieria tecnologia/';
      break;
    case '3':
      urlRef = 'programas/ciencias medicas/';
      break;
    case '4':
      urlRef = 'programas/ciencias agricolas/';
      break;
    case '5':
      urlRef = 'programas/ciencias sociales/';
      break;
    case '6':
      urlRef = 'programas/humanidades/';
      break;

    default:
      break;
  }
  // Create the file metadata
  const metadata = {
    contentType: file.type,
    size: file.size,
  };
  const storageRef = fire.storage().ref();
  // Upload file and metadata to the object 'images/mountains.jpg'
  const uploadTask = storageRef.child(urlRef + file.name).put(file, metadata);

  // Listen for state changes, errors, and completion of the upload.
  uploadTask.on(
    firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
    (snapshot) => {
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
      switch (snapshot.state) {
        case firebase.storage.TaskState.PAUSED: // or 'paused'
          console.log('Upload is paused');
          break;
        case firebase.storage.TaskState.RUNNING: // or 'running'
          console.log('Upload is running');
          break;
      }
    },
    function (error) {
      // A full list of error codes is available at
      // https://firebase.google.com/docs/storage/web/handle-errors
      switch (error.code) {
        case 'storage/unauthorized':
          dispatch({
            type: ERROR,
            payload:
              'El usuario no tiene permisos para hacer la operación o el archivo pesa más de 1MB.',
          });
          break;

        case 'storage/canceled':
          dispatch({
            type: ERROR,
            payload: "User canceled the upload'",
          });
          break;
        case 'storage/unknown':
          dispatch({
            type: ERROR,
            payload: 'Unknown error occurred, inspect error.serverResponse',
          });
          break;

        default:
          dispatch({
            type: ERROR,
            payload: 'Ocurrió un error',
          });
          console.log(error);
          break;
      }
    },
    () => {
      // Upload completed successfully, now we can get the download URL
      uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
        dispatch({ type: IMAGE_UPLOADED, payload: downloadURL });
      });
    }
  );
};
